<div class="bff-main-layout">
  <app-header (openSidebarEvent)="sidebarOpen = true"></app-header>
  <div class="bff-main-content">
    <div class="bff-main-content__left" [class.bff-main-content__left--open]="sidebarOpen">
      <app-sidebar (closeSidebarEvent)="sidebarOpen = false"></app-sidebar>
    </div>
    @if (sidebarOpen) {
      <div class="bff-sidebar-overlay" (click)="sidebarOpen = false"></div>
    }
    <div class="bff-main-content__right">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>